// extracted by mini-css-extract-plugin
module.exports = {"banner__description":"styles_banner__description__K2lu2","pulse":"styles_pulse__fdj29","jump":"styles_jump__l2BDI"};